import {
  Table,
  Paging,
  EllipsisSpan,
  usePaging,
  useUpdate,
  Form,
  Input,
  TreeSelect,
  CustomFilter,
  Modal,
} from '@maxtropy/components';
import { FC, useState, Key, useEffect } from 'react';
import { DefaultOptionType } from 'rc-tree-select/es/TreeSelect';
import { ColumnType } from 'antd/es/table';
import { getStaffOuPage, OuResponse, StaffOuRequest } from '../../../../api/staff';
import { OuStaffType, OuStaffTypeDisplay, OuStatus, OuStatusDisplay } from '../../../../api/const';
import { getOrganizationWithCodeWithCurrent } from '../../../../api/customer';
import { formatTreeData } from '../../../../lib/util';

export const ouColumns: ColumnType<OuResponse>[] = [
  {
    title: '运营单元编号',
    dataIndex: 'serialNumber',
    width: 200,
    render: v => <EllipsisSpan value={v} />,
  },
  {
    title: '运营单元名称',
    dataIndex: 'name',
    width: 200,
    render: (v: string) => <EllipsisSpan value={v} />,
  },
  {
    title: '状态',
    width: 100,
    dataIndex: 'status',
    render: (v: OuStatus) => <EllipsisSpan value={OuStatusDisplay[v]} />,
  },
  {
    title: '所属组织',
    width: 300,
    dataIndex: 'customerName',
    render: (v: number) => <EllipsisSpan value={String(v)} />,
  },
];

interface OuModalProps {
  staffId?: number;
  type?: OuStaffType;
  selectedOuData: (values: OuResponse[]) => void;
  onCancel: () => void;
}

type SearchParams = Omit<StaffOuRequest, 'size' | 'page' | 'type' | 'staffId'>;

const OuModal: FC<OuModalProps> = ({ staffId, type, selectedOuData, onCancel }) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [updateState] = useUpdate();

  const [searchForm] = Form.useForm();

  const [treeData, setTreeData] = useState<DefaultOptionType[]>([]);

  const [data, setData] = useState<Array<OuResponse>>([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [selectedRows, setSelectedRows] = useState<OuResponse[]>([]);

  const pagingInfo = usePaging(100);
  const { pageOffset, pageSize, setTotalCount, setPageOffset } = pagingInfo;

  const [searchParams, setSearchParams] = useState<SearchParams>();

  useEffect(() => {
    setLoading(true);
    getStaffOuPage({
      staffId,
      type: type!,
      page: pageOffset,
      size: pageSize,
      ...searchParams,
    })
      .then(res => {
        setData(res.list);
        setTotalCount(res.total);
      })
      .finally(() => {
        setLoading(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [staffId, pageOffset, type, pageSize, searchParams, updateState]);

  useEffect(() => {
    getOrganizationWithCodeWithCurrent().then(res => {
      setTreeData(formatTreeData([res]));
    });
  }, []);

  const onOk = () => {
    if (selectedRows.length > 0) {
      console.log('selectedRows', selectedRows);
      selectedOuData(selectedRows.map(item => ({ ...item, memberType: type! })));
      onCancel();
    } else {
      Modal.warning({
        title: '请先选择运营单元',
      });
    }
  };

  const rowSelection = {
    onChange: (selectedRowKeys: Key[], selectedRows: OuResponse[]) => {
      setSelectedRows(selectedRows);
      setSelectedRowKeys(selectedRowKeys);
    },
    preserveSelectedRowKeys: true,
    selectedRowKeys: selectedRowKeys,
  };

  const onFinish = (record: SearchParams) => {
    setPageOffset(1);
    setSearchParams(record);
  };

  const onReset = () => {
    setPageOffset(1);
    setSearchParams({});
  };

  return (
    <Modal
      size="big"
      open={type !== undefined}
      title={`添加为${type !== undefined ? OuStaffTypeDisplay[type] : ''}-运营单元选择`}
      onOk={onOk}
      onCancel={onCancel}
      destroyOnClose
    >
      <CustomFilter<SearchParams> form={searchForm} onFinish={onFinish} onReset={onReset} colSpan={8}>
        <Form.Item name="ouName" label="运营单元名称">
          <Input placeholder="请输入名称查询" maxLength={20} />
        </Form.Item>
        <Form.Item name="mcid" label="所在组织">
          <TreeSelect placeholder="请选择" treeData={treeData} />
        </Form.Item>
      </CustomFilter>
      <Table
        loading={loading}
        rowSelection={{
          type: 'checkbox',
          ...rowSelection,
        }}
        sticky
        scroll={{ y: 300 }}
        rowKey="id"
        columns={ouColumns}
        dataSource={data}
      />
      <Paging pagingInfo={pagingInfo} />
    </Modal>
  );
};

export default OuModal;
